import React from "react";
// import PermissionGate from "../../components/PermissionGate";
import { Helmet } from "react-helmet";
import Banner from "../../sections/Banner/Banner";
import QuickDiscovery from "../../sections/QuickDiscovery/QuickDiscovery";
import KnowledgeSeries from "../../sections/KnowledgeSeries/KnowledgeSeries";
import Mentors from "../../sections/Mentors/Mentors";
import Testimonials from "../../sections/Testimonials/Testimonials";
import AuthorSpotlight from "../../sections/AuthorSpotlight/AuthorSpotlight";
import Partners from "../../sections/Partners/Partners";
import Publishing from "../../sections/Publishing/Publishing";
import Appointments from "../../sections/Appointments/Appointments";
import PartnerProgram from "../../sections/PartnerProgram/PartnerProgram";
import Outcome from "../../sections/Outcomes/Outcomes";
import { useGetSiteInformationQuery } from "../../api/apiSlice";

export default function Home() {
  const { data: response } = useGetSiteInformationQuery();
  const apiData = response ? response.websiteInfo[0] : [];
  return (
    <div className="homePage">
      {apiData && (
        <>
          <Helmet>
            <title>{apiData.meta_title}</title>
            <meta name="description" content={apiData.meta_description} />
            <meta name="keywords" content={apiData.meta_keywords} />
            <meta property="og:title" content={apiData.meta_title} />
            <meta
              property="og:description"
              content={apiData.meta_description}
            />
          </Helmet>
        </>
      )}
      <Banner />
      <QuickDiscovery />
      <KnowledgeSeries />
      <PartnerProgram />
      <Mentors />
      <Testimonials />
      <AuthorSpotlight />
      <Partners />
      <Publishing />
      <Outcome />
      <Appointments />

      {/* <PermissionGate perm="view:partners">
        <PartnerProgram />
      </PermissionGate>
        */}
    </div>
  );
}
